import { AppointmentInformation } from '../components';
import { formatSlots } from '~/components/calendar-with-filters';

const { formatTimeToPeriod } = formatSlots;

export const config = {
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
  BookingReview: {
    hideShopAddress: true,
    displayUserAddress: true,
    BookingDate: {
      formatTimeSlot: startTime => formatTimeToPeriod(startTime),
    },
    icsEvent: {
      isServiceNameIncludedToAppointmentTypeName: true,
    },
    shopDetails: {
      title: 'Service provided by'
    }
  },
};
